const findWidgetName = (element) =>
	element?.closest?.('[data-widget-name]')?.dataset?.widgetName;

export default findWidgetName;
